import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import '../styles/components/language-switcher.css';

const LanguageSwitcher = ({ variant }) => {
  const { switchLanguage, t, isRTL } = useLanguage();
  const tl = (key) => t(`languageSwitcher.${key}`);

  const handleLanguageSwitch = () => {
    switchLanguage(isRTL ? 'fr' : 'ar');
  };

  const getLanguageLabel = () => (isRTL ? tl('labelAr') : tl('labelFr'));
  const getLanguageTitle = () => (isRTL ? tl('switchToFrench') : tl('switchToArabic'));

  const labelClass = `language-switcher-label ${isRTL ? 'language-switcher-label--ar' : 'language-switcher-label--fr'}`;

  if (variant === 'sidebar') {
    return (
      <button
        type="button"
        onClick={handleLanguageSwitch}
        className="language-switcher language-switcher--sidebar"
        title={getLanguageTitle()}
      >
        <Globe size={16} strokeWidth={1.35} aria-hidden />
        <span className={`language-switcher-sidebar-label ${labelClass}`}>
          {getLanguageLabel()}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleLanguageSwitch}
      className={`language-switcher language-switcher--${isRTL ? 'ar' : 'fr'}`}
      title={getLanguageTitle()}
    >
      <Globe size={16} className="language-switcher__icon" aria-hidden />
      <span className={labelClass}>
        {getLanguageLabel()}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
